/* Only oversized option labels wrap. Keep native radios and variant events intact. */
(() => {
  let queued = false;
  function fit() {
    queued = false;
    document.querySelectorAll('.astroclaro-pdp .bv5-native-option-values:not(.bv5-color-circles)').forEach(group => {
      const width = group.clientWidth;
      group.querySelectorAll('.bv5-native-option').forEach(button => {
        button.classList.remove('bv5-option-overlong');
        const labels = [...button.querySelectorAll('.bv5-size-main,.bv5-size-secondary')];
        if (labels.some(label => label.scrollWidth > width - 28)) button.classList.add('bv5-option-overlong');
      });
    });
  }
  const schedule = () => { if (!queued) { queued = true; requestAnimationFrame(fit); } };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', schedule, { once: true });
  else schedule();
  window.addEventListener('resize', schedule, { passive: true });
  document.fonts?.ready.then(schedule);
  const main = document.querySelector('main');
  if (main) new MutationObserver(schedule).observe(main, { childList: true, subtree: true });
})();
